import { useServerStatusStore } from '@src/utils/errorHandling/ServerStatusStore';
import { Paths } from '@src/config/paths';
import {
  shouldRedirectToLogin,
  appendLoginRedirectUrlParam,
} from '@src/utils/errorHandling/loginRedirect';
import { handleFetchError } from './handleFetchError';

const isAuthError = (data: Response) => {
  return data.status === 403;
};

export const secureFetch = (
  input: string | URL | globalThis.Request,
  init?: RequestInit,
) =>
  new Promise<Response>((resolve, reject) => {
    fetch(input, init)
      .then((data) => {
        if (
          !data.ok &&
          isAuthError(data) &&
          shouldRedirectToLogin(window.location)
        ) {
          window.location.href = appendLoginRedirectUrlParam(
            Paths.LOGIN,
            window.location.toString(),
          );
          return;
        }

        if (useServerStatusStore.getState().serverIsDown) {
          useServerStatusStore.getState().setServerIsDown(false);
        }
        resolve(data);
      })
      .catch((error: Error) => {
        const { shouldSetServerDown, shouldReject } = handleFetchError(error);

        if (shouldSetServerDown) {
          useServerStatusStore.getState().setServerIsDown(true);
        }

        if (shouldReject) {
          reject(error);
        }
      });
  });
